import { SumaSaldoInformeDtoProps } from "./DTOs/SumaSaldoInformeDto"

export const SumaSaldoAdapter = (sumaSaldo: SumaSaldoInformeDtoProps) => ({
  acumulado: sumaSaldo.acumulado,
  cuenta: sumaSaldo.cuenta,
  id: sumaSaldo.id,
  nombre: sumaSaldo.nombre,
  periodo: sumaSaldo.periodo,
})
